<template>
  <v-container>
    <v-row align="center" justify="center" v-if="!loading">
      <v-col cols="12" v-if="heading">
        <h1>{{ heading }}</h1>
      </v-col>
      <v-col cols="12">
        <transition name="fade" mode="out-in">
          <component v-bind="result"
                     :is="form"
                     @snackbar="openSnackbar"
                     @alert="openAlert" />
        </transition>
      </v-col>
    </v-row>
    <circular-progress v-else />
    <v-dialog v-model="alert.show" max-width="350">
      <v-card>
        <v-card-title class="headline">{{ alert.heading }}</v-card-title>
        <v-card-text>{{ alert.msg }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="accent"
                 text
                 @click="alert.show = false">
            Got It
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar.show" :timeout="-1">
      {{ snackbar.msg }}
      <v-btn color="accent" text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import Messages from '@/components/Mixins/Messages';

export default {
  mixins: [
    Messages,
  ],
  props: {
    form: {
      type: String,
      required: true,
    },
    method: {
      type: String,
      default: 'get',
    },
    api: Function,
    heading: String,
  },
  data() {
    return {
      loading: false,
      result: null,
    };
  },
  created() {
    if (this.api) {
      this.loading = true;
      const payload = this.api(this.$route);
      this.$store.dispatch(this.method, payload).then((response) => {
        this.result = response.data;
      }).finally(() => {
        this.loading = false;
      });
    }
  },
};
</script>
